import {pick} from 'lodash'
import queryString from 'query-string'
import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {Consumer} from '../../context'
import Text from 'react-text'
import Icon from '../icon'
import ChatItem from './chat-item'

export default function MenuItem (item) {
  const {order, page, section, direction, selected, query} = item
  return (<Consumer>{ context => {
    const {languageId, role, link, unreadMessages} = context
    const href = link({languageId, role, page, section}, '/:languageId/:role/:page/:section?', {query: query ? pick(context, query) : undefined})
    const MenuIcon = page == 'chat' ? ChatItem : Icon
    if (item.href) {
        return (<a
          className={`menu-item ${direction}${selected ? ' selected' : ''}`}
          href={item.href}>
            <MenuIcon name={page} unreadMessages={unreadMessages}/>
            <label>
              <Text id={`${page}_title`}/>
            </label>
        </a>
      )
    }
    return (<Link
      className={`menu-item ${direction}${selected ? ' selected' : ''}`}
      onClick={(e) => selected && e.preventDefault()}
      to={href}>
        <MenuIcon name={page} unreadMessages={unreadMessages}/>
        <label>
          <Text id={`${page}_title`}/>
        </label>
    </Link>
  )}}</Consumer>)
}
